module.exports = __webpack_public_path__ + "static/antd-dialog-fb10c2e52f734ba519d0dad747469539.png";